<template>
  <div
    class="primary d-flex flex-column pa-2"
    style="min-height: 100vh; overflow-y: hidden !important"
  >
    <v-btn icon @click="$emit('close')" :style="nav">
      <v-icon color="secondary"> mdi-close </v-icon>
    </v-btn>

    <v-text-field
      :style="nav"
      label="Αναζήτηση"
      v-model="keyword"
      append-icon="mdi-magnify"
      outlined
      round
      placeholder="Όνομα σημείου"
      @click:append="onSearch"
      @keydown.enter="onSearch"
      color="secondary"
    ></v-text-field>

    <div class="d-flex flex-column align-center justify-center" v-if="loader">
      <v-progress-circular indeterminate color="white" size="60">
      </v-progress-circular>
    </div>

    <div
      class="d-flex justify-center flex-row flex-wrap px-1"
      style="padding-bottom: 64px"
    >
      <v-card
        class="white mb-4"
        width="300"
        min-height="200"
        v-for="(poi, i) in pois"
        :key="i"
        @click="
          $router.push(`/pois/${poi.id}`);
          $emit('close');
        "
      >
        <div style="position: relative">
          <v-img
            :aspect-ratio="1 / 1"
            height="150"
            cover
            :src="`https://efales.mobics.gr/${poi.main_image}`"
          ></v-img>
        </div>

        <div class="body-1 px-2 pt-2 mb-1 secondary--text font-weight-bold">
          {{ poi.name }}
        </div>
        <div class="body-2 px-2 pb-2 secondary--text">
          {{
            decodeEntities(poi.description).length > 30
              ? decodeEntities(poi.description).substring(0, 30) + "..."
              : decodeEntities(poi.description)
          }}
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { decodeEntities } from "@/utils/decodeEntities";
import { mapState } from "vuex";

export default {
  data() {
    return {
      keyword: null,
      pois: [],
      loader: false,
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
    }),
    nav() {
      return {
        padding: `${this.insets?.top}px 0px 0px 0px`,
        // height: `${this.insets?.top}px`,
      };
    },
  },

  methods: {
    async onSearch() {
      this.loader = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
          params: {
            name: this.keyword,
          },
        });
        this.pois = res.data;
      } catch (e) {
        console.log(e);
      }
      this.loader = false;
    },

    decodeEntities(text) {
      return decodeEntities(text);
    },
  },
};
</script>

<style>
.v-input {
  flex: 0 1 auto !important;
}
</style>